import { WidgetsPackageDetailMain } from '@/widgets/package-detail';

export const PagesPackageDetailMain = () => <WidgetsPackageDetailMain />;
